function NewUser() {
    return {
        id: null,       
        userName: "New user",
		userPassword : "",
		roles: []
      }
}
export default NewUser;